export default __webpack_public_path__ + "static/media/iMAGE1_iexch.b473ddfd.png";